import { render, staticRenderFns } from "./RButtonGroup.vue?vue&type=template&id=d179c8b4&scoped=true&"
import script from "./RButtonGroup.vue?vue&type=script&lang=js&"
export * from "./RButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./RButtonGroup.vue?vue&type=style&index=0&id=d179c8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d179c8b4",
  null
  
)

export default component.exports